import {homeMenuList, auditMenuList, secadmMenuList, sysadminMenuList} from '@/common/utils/menu_list'
const menuObj = {
  homeMenuList,
  auditMenuList,
  secadmMenuList,
  sysadminMenuList
}
const state = {
  menuList: [],
  firstMenuInfo: {}
}

const mutations = {
  SET_USER_MENU_LIST: (state, view) => {
    state.menuList = view
    state.firstMenuInfo = view.find(item => item.isMenu) || {}

  }
}

const actions = {
  setUserMenuList({ commit }, view) {
    const menuList = menuObj[`${view}MenuList`] || menuObj.homeMenuList
    commit('SET_USER_MENU_LIST', menuList)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/setMenuList.js